<ng-container *ngIf="true">
    <mat-drawer-container class="drawer-container" autosize>
        <mat-tab-group #matTabGroup
                       [(selectedIndex)]="this.TabGroupSelectedIndex"
                       (selectedTabChange)="this.tabChanged()"
                       class="constraint-types-mat-tab-group">
            <mat-tab *ngFor="let tabName of this.TabNames; let i=index"
                     label="{{tabName}}"
                     [ngClass]="this.IsSelectectTab(i) ? 'selected-tab' : 'unselected-tab'"
                     style="{{this.getMatTabStyle(i)}}">
                <table mat-table
                       [dataSource]="this.ConstraintsListing(i)"
                       style="width: 100%; max-height: 100%;"
                       id="table-{{i}}">
                    <!-- Define columns. -->
                    <ng-container matColumnDef="constraintName"
                                  [sticky]="this.ColumnIsSticky('constraintName')">
                        <th mat-header-cell
                            *matHeaderCellDef
                            class="constraints-header-cell">
                            Name
                        </th>
                        <td mat-cell *matCellDef="let constraint">
                            <p class="constraint-name-p">{{constraint.name}}</p>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="constraintExpression"
                                  [sticky]="this.ColumnIsSticky('constraintExpression')">
                        <th mat-header-cell
                            *matHeaderCellDef
                            class="constraints-header-cell">
                            Expression
                        </th>
                        <td mat-cell *matCellDef="let constraint">
                            <div class="constraint-expression-summary-div">
                                <p class="constraint-expression-summary-p"
                                   title="{{this.getConstraintExprSummary(constraint)}}">
                                    {{this.getConstraintExprSummary(constraint)}}
                                </p>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="constraintUseCount"
                                  [sticky]="this.ColumnIsSticky('constraintUseCount')">
                        <th mat-header-cell
                            *matHeaderCellDef
                            class="constraints-header-cell">
                            # Uses
                        </th>
                        <td mat-cell *matCellDef="let constraint">
                            <span>{{this.ConstraintUseCount(constraint)}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="constraintActions"
                                  [sticky]="this.ColumnIsSticky('constraintActions')">
                        <th mat-header-cell
                            *matHeaderCellDef
                            class="constraints-header-cell">
                            Actions
                        </th>
                        <td mat-cell *matCellDef="let constraint">
                            <button mat-stroked-button
                                    [disabled]="this.EditConstraintButtonDisabled"
                                    (click)="this.editConstraint(constraint)">
                                <mat-icon class="constraint-action-button"
                                          title="{{this.EditConstraintTooltip}}"
                                          matTooltip="{{this.EditConstraintTooltip}}"
                                          [matTooltipPosition]="this.TooltipPosition">create</mat-icon>
                            </button>

                            <button mat-stroked-button
                                    [disabled]="this.TrashCanButtonDisabled(constraint)"
                                    (click)="this.deleteConstraint(constraint)">
                                <mat-icon class="constraint-action-button"
                                          title="{{this.TrashCanTooltip(constraint)}}"
                                          matTooltip="{{this.TrashCanTooltip(constraint)}}"
                                          [matTooltipPosition]="this.TooltipPosition">delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="addConstraintAction"
                                  [sticky]="this.ColumnIsSticky('addConstraintAction')">
                        <th mat-header-cell
                            *matHeaderCellDef
                            class="constraints-header-cell">
                            <button mat-stroked-button
                                    [disabled]="this.AddConstraintButtonDisabled"
                                    (click)="this.addNewConstraint()">
                                <mat-icon class="constraint-action-button"
                                          title="{{this.AddConstraintTooltip}}"
                                          matTooltip="{{this.AddConstraintTooltip}}"
                                          [matTooltipPosition]="this.TooltipPosition">add</mat-icon>
                            </button>
                        </th>
                        <td mat-cell *matCellDef="let constraint">
                        </td>
                    </ng-container>

                    <!-- Define the header row and data row template. -->
                    <tr mat-header-row *matHeaderRowDef="this.ConstraintsTableColumnNames; sticky: this.HeaderRowIsSticky"></tr>
                    <tr mat-row *matRowDef="let row; columns: this.ConstraintsTableColumnNames;"></tr>

                </table>
            </mat-tab>
        </mat-tab-group>

        <!-- Define the side drawer. -->
        <mat-drawer #drawer
                    mode="over"
                    position="end"
                    class="properties-drawer"
                    (closedStart)="this.drawerClosing()">

            <app-form-field-properties *ngIf="this.SelectedConstraint != null"
                                       [field]="this.SelectedField"
                                       [form]="this.SelectedForm"
                                       [properties]="this.SelectedFieldPropertyNames"
                                       [constraintNames]="this.SelectedFieldConstraintNames"
                                       [customRegexConstraintName]="this.CustomRegexConstraintName"
                                       [displayFormatValues]="this.SelectedFieldDisplayFormatValues"
                                       [displayRowsValues]="this.SelectedFieldDisplayRowsValues"
                                       [basicPropertiesExpanded]="this.BasicPropertiesExpanded"
                                       (onClose)="this.closeFieldPropertiesDrawer($event)"
                                       (propertyChanged)="this.fieldPropertyChanged($event)"></app-form-field-properties>

        </mat-drawer>
    </mat-drawer-container>
</ng-container>

